const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const passwordRegex = /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

const urlRegex = /(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/;

const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

//constants
const requiredConstant = 'This field is required';
const emailValidConstant = 'Please enter valid Email ID';
const urlValidConstant = 'Please enter valid URL';
const phoneValidConstant = 'Please enter valid PhoneNumber';
const passwordValidConstant =
  'Password must be 8-16 characters; must have numbers, upper & lowercase letters and special characters.';
const TransactionTypes = {
  Debit: 'DEBIT',
  Cash: 'CASH',
  Cheque: 'CHEQUE',
};

const urlConstants = {
  deals_s3_url: 'https://8vdx-deals.s3.amazonaws.com/index.html',
  terms_s3_url: 'https://8vdx-terms.s3.amazonaws.com/index.html',
  signUp_url: '/users/investor/signup',
  getInvestorDetail_url: 'investors/investor/get',
  updateInvestorDetail_url: 'investors/investor/update',
  createUpdateInvestorKyc_url: 'investors/kyc/create',
  createInvestmentDetail_url: 'investors/investment/create',
  getInvestmentTrack_url: 'investors/investor/investment-track',
  getDocuSignDocuments: 'investors/investor/sign-documents',
  uploadFileSignedUrl: 'documents/investor/get-document-signed-url',
  addInvestmentDocument: 'documents/investor/add-document',
  getInvestmentDocument: 'documents/investor/investment-documents',
  inviteInvestorUser: 'users/investor/invite',
  updateInvestorUser: 'users/investor',
  deleteInvestorUser: 'users/investor',
  getExistingEmails: 'users/existing-emails',
  getInvestorUsers: 'users/investor',
  getInvestorPayments: 'investors/investor/payments',
  getInvestorPortfolio: 'investors/investor/portfolio',
  getInvestorAggregatePortfolio: 'investors/investor/aggregate-portfolio',
  getInvestorNavTrack: 'investors/investor-nav-track',
  getKycSSN: 'investors/investor/get-kyc-ssn',
  getSubscriberSSN: 'investors/investor/get-subscriber-ssn',
  getInvestorAllDeals: 'deals/investor/deals',
  getInvestorDealById: 'deals/deal',
  getUpcomingDistributions: 'investors/get-upcoming-distributions',
  addRolloverInvestment: 'investors/add-rollover-investment',
  addInvestorDocumentByName: 'documents/investor/add-investor-document',
  getDealUpdates: 'deals/get-deal-updates',
  referInvestor: 'referral/investor/refer-investor',
  getInvestorAllReferral: 'referral/get-investor-referral',
  resendReferInviteToInvestor: 'referral/investor/resend-invite',
  getDealToVisit: 'referral/investor/get-deal-to-visit',
  refereeInvestorVisitedDeal: 'referral/investor/visit-deal',
  checkReferralEmailRegistered: 'referral/investor/email-registered',
  getInvestments: 'investors/get-investments',
  markDocusignSigned: 'investors/mark-docusigned',
};

const STATIC_WEBSITE: Record<string, string> = {
  dev: 'http://qa.8vdx.com.s3-website-us-east-1.amazonaws.com/',
  qa: 'http://qa.8vdx.com.s3-website-us-east-1.amazonaws.com/',
  stage: 'https://stage.8vdx.com/',
  prod: 'https://8vdx.com/',
};

const VC_STATIC_WEBSITE: Record<string, string> = {
  dev: 'https://dev-vcinvestor.8vdx.com/',
  qa: 'https://qa-vcinvestor.8vdx.com/',
  stage: 'https://stage-vcinvestor.8vdx.com/',
  prod: 'https://vcinvestor.8vdx.com/',
};

//font family
const fontFamily = 'mulish';

const ROLES_OPTION = [
  { text: 'ADMIN', value: 'ADMIN' },
  { text: 'ADMIN', value: 'INVESTOR_ADMIN' },
];

const fundingEntityType = {
  Individual: 'INDIVIDUAL',
  Entity: 'ENTITY',
};

const FUNDING_ENTITY_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  ENTITY: 'ENTITY',
};

const DEAL_TYPE = {
  FUND: 'FUND',
  STARTUP: 'STARTUP',
};

const REINVEST_TYPE = {
  PARTIAL: 'PARTIAL',
  FULL: 'FULL',
};

const REFERRAL_STATUS_TYPE: any = {
  INVITED: 'Yet to sign up',
  REGISTERED_WITH_DIFFERENT_REFERRAL: 'Registered with different referral',
  SIGNED_UP: 'Signed up',
  INVESTED: 'Invested in deal',
  DEAL_CLOSED: 'Deal Closed',
};

const REFERRAL_STATUS: any = {
  INVITED: 'INVITED',
  REGISTERED_WITH_DIFFERENT_REFERRAL: 'REGISTERED_WITH_DIFFERENT_REFERRAL',
  SIGNED_UP: 'SIGNED_UP',
  INVESTED: 'INVESTED',
  DEAL_CLOSED: 'DEAL_CLOSED',
};

export {
  emailRegex,
  passwordRegex,
  urlRegex,
  phoneRegex,
  requiredConstant,
  emailValidConstant,
  passwordValidConstant,
  urlValidConstant,
  phoneValidConstant,
  fontFamily,
  urlConstants,
  TransactionTypes,
  STATIC_WEBSITE,
  fundingEntityType,
  ROLES_OPTION,
  FUNDING_ENTITY_TYPE,
  DEAL_TYPE,
  REINVEST_TYPE,
  REFERRAL_STATUS_TYPE,
  REFERRAL_STATUS,
  VC_STATIC_WEBSITE,
};
